/* tslint:disable */
/* eslint-disable */
/**
 * Web API v0-demo
 * NexusFleet SaaS
 *
 * The version of the OpenAPI document: 0
 * Contact: info@nexusops.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface DateRangeDto
 */
export interface DateRangeDto {
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DateRangeDto
     */
    'from'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof DateRangeDto
     */
    'to'?: string | null;
}
/**
 * 
 * @export
 * @interface FilterDefinitionDto
 */
export interface FilterDefinitionDto {
    /**
     * 
     * @type {Array<FilterDefinitionItemDto>}
     * @memberof FilterDefinitionDto
     */
    'items'?: Array<FilterDefinitionItemDto> | null;
}
/**
 * 
 * @export
 * @interface FilterDefinitionItemDto
 */
export interface FilterDefinitionItemDto {
    /**
     * 
     * @type {FilterType}
     * @memberof FilterDefinitionItemDto
     */
    'type'?: FilterType;
    /**
     * 
     * @type {string}
     * @memberof FilterDefinitionItemDto
     */
    'field'?: string;
    /**
     * 
     * @type {FilterOperator}
     * @memberof FilterDefinitionItemDto
     */
    'operator'?: FilterOperator;
    /**
     * 
     * @type {FilterValueType}
     * @memberof FilterDefinitionItemDto
     */
    'valueType'?: FilterValueType;
    /**
     * 
     * @type {any}
     * @memberof FilterDefinitionItemDto
     */
    'value'?: any | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FilterOperator = {
    None: 'None',
    Equal: 'Equal',
    NotEqual: 'NotEqual',
    Contain: 'Contain',
    NotContain: 'NotContain',
    LessThan: 'LessThan',
    LessThanOrEqual: 'LessThanOrEqual',
    GreaterThan: 'GreaterThan',
    GreaterThanOrEqual: 'GreaterThanOrEqual',
    AnyOf: 'AnyOf',
    NoneOf: 'NoneOf',
    Empty: 'Empty',
    NotEmpty: 'NotEmpty'
} as const;

export type FilterOperator = typeof FilterOperator[keyof typeof FilterOperator];


/**
 * 
 * @export
 * @enum {string}
 */

export const FilterType = {
    None: 'None',
    Static: 'Static',
    Dynamic: 'Dynamic'
} as const;

export type FilterType = typeof FilterType[keyof typeof FilterType];


/**
 * 
 * @export
 * @enum {string}
 */

export const FilterValueType = {
    None: 'None',
    Arbitrary: 'Arbitrary',
    String: 'String',
    Number: 'Number',
    Boolean: 'Boolean',
    Date: 'Date',
    Enum: 'Enum',
    Id: 'Id',
    ArrayOfString: 'ArrayOfString',
    ArrayOfEnum: 'ArrayOfEnum',
    ArrayOfId: 'ArrayOfId'
} as const;

export type FilterValueType = typeof FilterValueType[keyof typeof FilterValueType];


/**
 * 
 * @export
 * @interface PaginationDtoOfTeslaConnectionDto
 */
export interface PaginationDtoOfTeslaConnectionDto {
    /**
     * 
     * @type {Array<TeslaConnectionDto>}
     * @memberof PaginationDtoOfTeslaConnectionDto
     */
    'items'?: Array<TeslaConnectionDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfTeslaConnectionDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationDtoOfTeslaVehicleListItemDto
 */
export interface PaginationDtoOfTeslaVehicleListItemDto {
    /**
     * 
     * @type {Array<TeslaVehicleListItemDto>}
     * @memberof PaginationDtoOfTeslaVehicleListItemDto
     */
    'items'?: Array<TeslaVehicleListItemDto>;
    /**
     * 
     * @type {PaginationInfoDto}
     * @memberof PaginationDtoOfTeslaVehicleListItemDto
     */
    'pagination'?: PaginationInfoDto;
}
/**
 * 
 * @export
 * @interface PaginationInfoDto
 */
export interface PaginationInfoDto {
    /**
     * Total number of records in the requested dataset.
     * @type {number}
     * @memberof PaginationInfoDto
     */
    'totalCount'?: number;
    /**
     * Zero-based offset.
     * @type {number}
     * @memberof PaginationInfoDto
     */
    'offset'?: number;
    /**
     * The same as page size.
     * @type {number}
     * @memberof PaginationInfoDto
     */
    'limit'?: number;
    /**
     * Current page zero-based index.
     * @type {number}
     * @memberof PaginationInfoDto
     */
    'currentPage'?: number;
    /**
     * Total number of pages.
     * @type {number}
     * @memberof PaginationInfoDto
     */
    'totalPages'?: number;
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * Defines sorting on one or multiple fields.
 * @export
 * @interface SortDefinitionDto
 */
export interface SortDefinitionDto {
    /**
     * Comma-separated list of fields to sort by.
     * @type {string}
     * @memberof SortDefinitionDto
     */
    'sortBy'?: string | null;
    /**
     * Comma-separated list of sort orders, with indexes corresponding to fields.  See values in SortOrder enum.
     * @type {string}
     * @memberof SortDefinitionDto
     */
    'sortOrder'?: string | null;
}
/**
 * 
 * @export
 * @interface TeslaAuthAuthorizationCodeExchangeRequestDto
 */
export interface TeslaAuthAuthorizationCodeExchangeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TeslaAuthAuthorizationCodeExchangeRequestDto
     */
    'scope'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaAuthAuthorizationCodeExchangeRequestDto
     */
    'redirectUri'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaAuthAuthorizationCodeExchangeRequestDto
     */
    'authorizationCode'?: string;
}
/**
 * 
 * @export
 * @interface TeslaAuthInfoDto
 */
export interface TeslaAuthInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TeslaAuthInfoDto
     */
    'teslaConnectionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeslaAuthInfoDto
     */
    'vehicleId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaAuthInfoDto
     */
    'isAccountConnected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaAuthInfoDto
     */
    'isAccessTokenExpired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaAuthInfoDto
     */
    'isAuthenticated'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TeslaAuthTokenType = {
    None: 'None',
    Partner: 'Partner',
    ThirdParty: 'ThirdParty',
    OpenSource: 'OpenSource'
} as const;

export type TeslaAuthTokenType = typeof TeslaAuthTokenType[keyof typeof TeslaAuthTokenType];


/**
 * 
 * @export
 * @interface TeslaAuthorizationCodeExchangeResponseDto
 */
export interface TeslaAuthorizationCodeExchangeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TeslaAuthorizationCodeExchangeResponseDto
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof TeslaAuthorizationCodeExchangeResponseDto
     */
    'id_token': string;
    /**
     * Set if using the offline_access scope.
     * @type {string}
     * @memberof TeslaAuthorizationCodeExchangeResponseDto
     */
    'refresh_token'?: string | null;
    /**
     * Usually it\'s 8 hours.
     * @type {number}
     * @memberof TeslaAuthorizationCodeExchangeResponseDto
     */
    'expires_in': number;
    /**
     * 
     * @type {string}
     * @memberof TeslaAuthorizationCodeExchangeResponseDto
     */
    'state': string;
    /**
     * The type of token (e.g., Bearer) - always \"Bearer\" in this case.
     * @type {string}
     * @memberof TeslaAuthorizationCodeExchangeResponseDto
     */
    'token_type': string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaAuthorizationCodeExchangeResponseDto
     */
    'expiresAt'?: string;
}
/**
 * 
 * @export
 * @interface TeslaConnectionAuthTokensInfoDto
 */
export interface TeslaConnectionAuthTokensInfoDto {
    /**
     * 
     * @type {TeslaAuthTokenType}
     * @memberof TeslaConnectionAuthTokensInfoDto
     */
    'type'?: TeslaAuthTokenType;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaConnectionAuthTokensInfoDto
     */
    'refreshedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaConnectionAuthTokensInfoDto
     */
    'refreshAccessTokenAfter'?: string;
}


/**
 * 
 * @export
 * @interface TeslaConnectionDto
 */
export interface TeslaConnectionDto {
    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionDto
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionDto
     */
    'userEmail'?: string;
    /**
     * 
     * @type {TeslaConnectionAuthTokensInfoDto}
     * @memberof TeslaConnectionDto
     */
    'tokens'?: TeslaConnectionAuthTokensInfoDto;
    /**
     * 
     * @type {TeslaConnectionAuthTokensInfoDto}
     * @memberof TeslaConnectionDto
     */
    'prevTokens'?: TeslaConnectionAuthTokensInfoDto;
    /**
     * 
     * @type {Array<TeslaConnectionVehicleDto>}
     * @memberof TeslaConnectionDto
     */
    'vehicles'?: Array<TeslaConnectionVehicleDto>;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaConnectionDto
     */
    'vehiclesUpdatedAt'?: string | null;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaConnectionDto
     */
    'createdAt'?: string;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaConnectionDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionDto
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionDto
     */
    'updatedBy'?: string | null;
}
/**
 * 
 * @export
 * @interface TeslaConnectionGetPaginatedDto
 */
export interface TeslaConnectionGetPaginatedDto {
    /**
     * 
     * @type {number}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'includeIds'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'excludeIds'?: Array<string> | null;
    /**
     * 
     * @type {DateRangeDto}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'range'?: DateRangeDto;
    /**
     * 
     * @type {SortDefinitionDto}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'sortDefinition'?: SortDefinitionDto;
    /**
     * 
     * @type {FilterDefinitionDto}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'filterDefinition'?: FilterDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'userEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionGetPaginatedDto
     */
    'vin'?: string | null;
}
/**
 * 
 * @export
 * @interface TeslaConnectionVehicleDto
 */
export interface TeslaConnectionVehicleDto {
    /**
     * Local ID for Tesla Fleet API (id field).
     * @type {number}
     * @memberof TeslaConnectionVehicleDto
     */
    'vehicleRecordId'?: number;
    /**
     * Global vehicle ID (vehicle_id field).
     * @type {number}
     * @memberof TeslaConnectionVehicleDto
     */
    'vehicleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionVehicleDto
     */
    'vin'?: string;
}
/**
 * 
 * @export
 * @interface TeslaFeatureInfoDto
 */
export interface TeslaFeatureInfoDto {
    /**
     * 
     * @type {string}
     * @memberof TeslaFeatureInfoDto
     */
    'environmentName': string;
    /**
     * 
     * @type {string}
     * @memberof TeslaFeatureInfoDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TeslaFeatureInfoDto
     */
    'userEmail': string;
    /**
     * 
     * @type {string}
     * @memberof TeslaFeatureInfoDto
     */
    'vehicleId': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaFeatureInfoDto
     */
    'isEnabledForEnvironment': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaFeatureInfoDto
     */
    'isEnabledForUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaFeatureInfoDto
     */
    'isEnabledForVehicle': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaFeatureInfoDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface TeslaVehicleCommandResultDto
 */
export interface TeslaVehicleCommandResultDto {
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleCommandResultDto
     */
    'result'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleCommandResultDto
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface TeslaVehicleDataChargeStateDto
 */
export interface TeslaVehicleDataChargeStateDto {
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataChargeStateDto
     */
    'battery_level'?: number;
    /**
     * In miles.
     * @type {number}
     * @memberof TeslaVehicleDataChargeStateDto
     */
    'battery_range'?: number;
    /**
     * Values: Disconnected
     * @type {string}
     * @memberof TeslaVehicleDataChargeStateDto
     */
    'charging_state'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataChargeStateDto
     */
    'timestamp'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataChargeStateDto
     */
    'batteryRangeMi'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataChargeStateDto
     */
    'batteryRangeKm'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaVehicleDataChargeStateDto
     */
    'timestampAsDate'?: string;
}
/**
 * 
 * @export
 * @interface TeslaVehicleDataDriveStateDto
 */
export interface TeslaVehicleDataDriveStateDto {
    /**
     * Timestamp in secs.
     * @type {number}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'gps_as_of'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'native_latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'native_longitude'?: number | null;
    /**
     * Values: wgs
     * @type {string}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'native_type'?: string | null;
    /**
     * This property indicates the direction in which the car is currently facing,  measured in degrees (where 0 or 360 is North, 90 is East, 180 is South, and 270 is West).
     * @type {number}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'heading'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'power'?: number | null;
    /**
     * Values: P, R, N, D
     * @type {string}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'shift_state'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'speed'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'timestamp'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'timestampAsDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleDataDriveStateDto
     */
    'isEngineOn'?: boolean;
}
/**
 * 
 * @export
 * @interface TeslaVehicleDataDto
 */
export interface TeslaVehicleDataDto {
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataDto
     */
    'id'?: number;
    /**
     * The id_s field is a string version of the id field (for cases when JSON parser doesn\'t support large numbers (>32 bit)).
     * @type {string}
     * @memberof TeslaVehicleDataDto
     */
    'id_s'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataDto
     */
    'user_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataDto
     */
    'vehicle_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleDataDto
     */
    'vin'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleDataDto
     */
    'access_type'?: string;
    /**
     * Values: offline, asleep, online, driving, parked
     * @type {string}
     * @memberof TeslaVehicleDataDto
     */
    'state'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataDto
     */
    'api_version'?: number;
    /**
     * 
     * @type {TeslaVehicleDataChargeStateDto}
     * @memberof TeslaVehicleDataDto
     */
    'charge_state'?: TeslaVehicleDataChargeStateDto;
    /**
     * 
     * @type {TeslaVehicleDataDriveStateDto}
     * @memberof TeslaVehicleDataDto
     */
    'drive_state'?: TeslaVehicleDataDriveStateDto;
    /**
     * 
     * @type {TeslaVehicleDataVehicleStateDto}
     * @memberof TeslaVehicleDataDto
     */
    'vehicle_state'?: TeslaVehicleDataVehicleStateDto;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaVehicleDataDto
     */
    'fetchedAt'?: string;
    /**
     * 
     * @type {TeslaVehicleStateCustom}
     * @memberof TeslaVehicleDataDto
     */
    'stateCustom'?: TeslaVehicleStateCustom;
}


/**
 * 
 * @export
 * @interface TeslaVehicleDataVehicleStateDto
 */
export interface TeslaVehicleDataVehicleStateDto {
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'api_version'?: number;
    /**
     * Firmware version.  E.g. 2024.26.7 b7e14964b659
     * @type {string}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'car_version'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'locked'?: boolean;
    /**
     * In miles.
     * @type {number}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'odometer'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'timestamp'?: number;
    /**
     * Indicates the state of the vehicle\'s four doors.  If 0, the door is closed. If 1, the door is open.
     * @type {number}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'df'?: number;
    /**
     * Driver side rear door
     * @type {number}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'dr'?: number;
    /**
     * Passenger side front door
     * @type {number}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'pf'?: number;
    /**
     * Passenger side rear door
     * @type {number}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'pr'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'mileageMi'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'mileageKm'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'timestampAsDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'isLocked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'isUnlocked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'isAnyDoorOpen'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'isAllDoorsClosed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'isDriverFrontDoorOpen'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'isDriverRearDoorOpen'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'isPassengerFrontDoorOpen'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleDataVehicleStateDto
     */
    'isPassengerRearDoorOpen'?: boolean;
}
/**
 * https://developer.tesla.com/docs/fleet-api/endpoints/vehicle-endpoints#vehicle
 * @export
 * @interface TeslaVehicleDto
 */
export interface TeslaVehicleDto {
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDto
     */
    'id'?: number;
    /**
     * The id_s field is a string version of the id field (for cases when JSON parser doesn\'t support large numbers (>32 bit)).
     * @type {string}
     * @memberof TeslaVehicleDto
     */
    'id_s'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDto
     */
    'vehicle_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleDto
     */
    'vin'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleDto
     */
    'access_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleDto
     */
    'display_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleDto
     */
    'state'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleDto
     */
    'api_version'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaVehicleDto
     */
    'fetchedAt'?: string;
    /**
     * 
     * @type {TeslaVehicleStateCustom}
     * @memberof TeslaVehicleDto
     */
    'stateCustom'?: TeslaVehicleStateCustom;
}


/**
 * 
 * @export
 * @interface TeslaVehicleGetPaginatedDto
 */
export interface TeslaVehicleGetPaginatedDto {
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleGetPaginatedDto
     */
    'teslaConnectionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleGetPaginatedDto
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleGetPaginatedDto
     */
    'limit'?: number;
}
/**
 * https://developer.tesla.com/docs/fleet-api/endpoints/vehicle-endpoints#list
 * @export
 * @interface TeslaVehicleListItemDto
 */
export interface TeslaVehicleListItemDto {
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleListItemDto
     */
    'id'?: number;
    /**
     * The id_s field is a string version of the id field (for cases when JSON parser doesn\'t support large numbers (>32 bit)).
     * @type {string}
     * @memberof TeslaVehicleListItemDto
     */
    'id_s'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleListItemDto
     */
    'vehicle_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleListItemDto
     */
    'vin'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleListItemDto
     */
    'access_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleListItemDto
     */
    'display_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleListItemDto
     */
    'state'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleListItemDto
     */
    'api_version'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaVehicleListItemDto
     */
    'fetchedAt'?: string;
}
/**
 * Confirmed typed states computed from string state from Tesla API.
 * @export
 * @enum {string}
 */

export const TeslaVehicleStateCustom = {
    None: 'None',
    Offline: 'Offline',
    Asleep: 'Asleep',
    Online: 'Online'
} as const;

export type TeslaVehicleStateCustom = typeof TeslaVehicleStateCustom[keyof typeof TeslaVehicleStateCustom];


/**
 * https://developer.tesla.com/docs/fleet-api/endpoints/vehicle-endpoints#wake-up
 * @export
 * @interface TeslaVehicleWakeUpResultDto
 */
export interface TeslaVehicleWakeUpResultDto {
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'id'?: number;
    /**
     * The id_s field is a string version of the id field (for cases when JSON parser doesn\'t support large numbers (>32 bit)).
     * @type {string}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'id_s'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'user_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'vehicle_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'vin'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'access_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'state'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'in_service'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'calendar_enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'api_version'?: number;
    /**
     * Date-time string in <a href=\"https://en.wikipedia.org/wiki/ISO_8601#UTC\\\">ISO 8601 format</a>.
     * @type {string}
     * @memberof TeslaVehicleWakeUpResultDto
     */
    'fetchedAt'?: string;
}
/**
 * 
 * @export
 * @interface ValidationProblemDetails
 */
export interface ValidationProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationProblemDetails
     */
    'instance'?: string | null;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ValidationProblemDetails
     */
    'errors'?: { [key: string]: Array<string>; };
}

/**
 * TeslaAuthApi - axios parameter creator
 * @export
 */
export const TeslaAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Exchanges the authorization code (in authorization_code grant flow) for a Tesla third-party access token.  Docs - https://developer.tesla.com/docs/fleet-api/authentication/third-party-tokens.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TeslaAuthAuthorizationCodeExchangeRequestDto} [teslaAuthAuthorizationCodeExchangeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaAuthCodeExchangeRequestPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, teslaAuthAuthorizationCodeExchangeRequestDto?: TeslaAuthAuthorizationCodeExchangeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaAuthCodeExchangeRequestPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v0.1-demo/providers/tesla/auth/code-exchange/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teslaAuthAuthorizationCodeExchangeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [vehicleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaAuthInfoGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaAuthInfoGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v0.1-demo/providers/tesla/auth/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeslaAuthApi - functional programming interface
 * @export
 */
export const TeslaAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeslaAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Exchanges the authorization code (in authorization_code grant flow) for a Tesla third-party access token.  Docs - https://developer.tesla.com/docs/fleet-api/authentication/third-party-tokens.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TeslaAuthAuthorizationCodeExchangeRequestDto} [teslaAuthAuthorizationCodeExchangeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaAuthCodeExchangeRequestPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, teslaAuthAuthorizationCodeExchangeRequestDto?: TeslaAuthAuthorizationCodeExchangeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaAuthorizationCodeExchangeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaAuthCodeExchangeRequestPost(nexusOpsTenant, nexusOpsAppVersion, teslaAuthAuthorizationCodeExchangeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaAuthApi.apiV01DemoProvidersTeslaAuthCodeExchangeRequestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [vehicleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaAuthInfoGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaAuthInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaAuthInfoGet(nexusOpsTenant, nexusOpsAppVersion, vehicleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaAuthApi.apiV01DemoProvidersTeslaAuthInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeslaAuthApi - factory interface
 * @export
 */
export const TeslaAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeslaAuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Exchanges the authorization code (in authorization_code grant flow) for a Tesla third-party access token.  Docs - https://developer.tesla.com/docs/fleet-api/authentication/third-party-tokens.
         * @param {TeslaAuthApiApiV01DemoProvidersTeslaAuthCodeExchangeRequestPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaAuthCodeExchangeRequestPost(requestParameters: TeslaAuthApiApiV01DemoProvidersTeslaAuthCodeExchangeRequestPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaAuthorizationCodeExchangeResponseDto> {
            return localVarFp.apiV01DemoProvidersTeslaAuthCodeExchangeRequestPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.teslaAuthAuthorizationCodeExchangeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaAuthApiApiV01DemoProvidersTeslaAuthInfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaAuthInfoGet(requestParameters: TeslaAuthApiApiV01DemoProvidersTeslaAuthInfoGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaAuthInfoDto> {
            return localVarFp.apiV01DemoProvidersTeslaAuthInfoGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV01DemoProvidersTeslaAuthCodeExchangeRequestPost operation in TeslaAuthApi.
 * @export
 * @interface TeslaAuthApiApiV01DemoProvidersTeslaAuthCodeExchangeRequestPostRequest
 */
export interface TeslaAuthApiApiV01DemoProvidersTeslaAuthCodeExchangeRequestPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaAuthApiApiV01DemoProvidersTeslaAuthCodeExchangeRequestPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaAuthApiApiV01DemoProvidersTeslaAuthCodeExchangeRequestPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TeslaAuthAuthorizationCodeExchangeRequestDto}
     * @memberof TeslaAuthApiApiV01DemoProvidersTeslaAuthCodeExchangeRequestPost
     */
    readonly teslaAuthAuthorizationCodeExchangeRequestDto?: TeslaAuthAuthorizationCodeExchangeRequestDto
}

/**
 * Request parameters for apiV01DemoProvidersTeslaAuthInfoGet operation in TeslaAuthApi.
 * @export
 * @interface TeslaAuthApiApiV01DemoProvidersTeslaAuthInfoGetRequest
 */
export interface TeslaAuthApiApiV01DemoProvidersTeslaAuthInfoGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaAuthApiApiV01DemoProvidersTeslaAuthInfoGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaAuthApiApiV01DemoProvidersTeslaAuthInfoGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof TeslaAuthApiApiV01DemoProvidersTeslaAuthInfoGet
     */
    readonly vehicleId?: string
}

/**
 * TeslaAuthApi - object-oriented interface
 * @export
 * @class TeslaAuthApi
 * @extends {BaseAPI}
 */
export class TeslaAuthApi extends BaseAPI {
    /**
     * 
     * @summary Exchanges the authorization code (in authorization_code grant flow) for a Tesla third-party access token.  Docs - https://developer.tesla.com/docs/fleet-api/authentication/third-party-tokens.
     * @param {TeslaAuthApiApiV01DemoProvidersTeslaAuthCodeExchangeRequestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaAuthApi
     */
    public apiV01DemoProvidersTeslaAuthCodeExchangeRequestPost(requestParameters: TeslaAuthApiApiV01DemoProvidersTeslaAuthCodeExchangeRequestPostRequest, options?: RawAxiosRequestConfig) {
        return TeslaAuthApiFp(this.configuration).apiV01DemoProvidersTeslaAuthCodeExchangeRequestPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.teslaAuthAuthorizationCodeExchangeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaAuthApiApiV01DemoProvidersTeslaAuthInfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaAuthApi
     */
    public apiV01DemoProvidersTeslaAuthInfoGet(requestParameters: TeslaAuthApiApiV01DemoProvidersTeslaAuthInfoGetRequest, options?: RawAxiosRequestConfig) {
        return TeslaAuthApiFp(this.configuration).apiV01DemoProvidersTeslaAuthInfoGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeslaConnectionsApi - axios parameter creator
 * @export
 */
export const TeslaConnectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TeslaConnectionGetPaginatedDto} [teslaConnectionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaConnectionsGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, teslaConnectionGetPaginatedDto?: TeslaConnectionGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaConnectionsGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v0.1-demo/providers/tesla/connections/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teslaConnectionGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} teslaConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost: async (nexusOpsTenant: string, teslaConnectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'teslaConnectionId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost', 'teslaConnectionId', teslaConnectionId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/connections/{teslaConnectionId}/auth-tokens/refresh`
                .replace(`{${"teslaConnectionId"}}`, encodeURIComponent(String(teslaConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} teslaConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete: async (nexusOpsTenant: string, teslaConnectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'teslaConnectionId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete', 'teslaConnectionId', teslaConnectionId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/connections/{teslaConnectionId}`
                .replace(`{${"teslaConnectionId"}}`, encodeURIComponent(String(teslaConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} teslaConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet: async (nexusOpsTenant: string, teslaConnectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'teslaConnectionId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet', 'teslaConnectionId', teslaConnectionId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/connections/{teslaConnectionId}`
                .replace(`{${"teslaConnectionId"}}`, encodeURIComponent(String(teslaConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} teslaConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost: async (nexusOpsTenant: string, teslaConnectionId: string, nexusOpsAppVersion?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'teslaConnectionId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost', 'teslaConnectionId', teslaConnectionId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/connections/{teslaConnectionId}/vehicles/refresh`
                .replace(`{${"teslaConnectionId"}}`, encodeURIComponent(String(teslaConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeslaConnectionsApi - functional programming interface
 * @export
 */
export const TeslaConnectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeslaConnectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TeslaConnectionGetPaginatedDto} [teslaConnectionGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaConnectionsGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, teslaConnectionGetPaginatedDto?: TeslaConnectionGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfTeslaConnectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaConnectionsGetPost(nexusOpsTenant, nexusOpsAppVersion, teslaConnectionGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaConnectionsApi.apiV01DemoProvidersTeslaConnectionsGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} teslaConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost(nexusOpsTenant: string, teslaConnectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaConnectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost(nexusOpsTenant, teslaConnectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaConnectionsApi.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} teslaConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete(nexusOpsTenant: string, teslaConnectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete(nexusOpsTenant, teslaConnectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaConnectionsApi.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} teslaConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet(nexusOpsTenant: string, teslaConnectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaConnectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet(nexusOpsTenant, teslaConnectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaConnectionsApi.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} teslaConnectionId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost(nexusOpsTenant: string, teslaConnectionId: string, nexusOpsAppVersion?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaConnectionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost(nexusOpsTenant, teslaConnectionId, nexusOpsAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaConnectionsApi.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeslaConnectionsApi - factory interface
 * @export
 */
export const TeslaConnectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeslaConnectionsApiFp(configuration)
    return {
        /**
         * 
         * @param {TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaConnectionsGetPost(requestParameters: TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfTeslaConnectionDto> {
            return localVarFp.apiV01DemoProvidersTeslaConnectionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.teslaConnectionGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost(requestParameters: TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaConnectionDto> {
            return localVarFp.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost(requestParameters.nexusOpsTenant, requestParameters.teslaConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete(requestParameters: TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete(requestParameters.nexusOpsTenant, requestParameters.teslaConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet(requestParameters: TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaConnectionDto> {
            return localVarFp.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet(requestParameters.nexusOpsTenant, requestParameters.teslaConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost(requestParameters: TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaConnectionDto> {
            return localVarFp.apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost(requestParameters.nexusOpsTenant, requestParameters.teslaConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV01DemoProvidersTeslaConnectionsGetPost operation in TeslaConnectionsApi.
 * @export
 * @interface TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsGetPostRequest
 */
export interface TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TeslaConnectionGetPaginatedDto}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsGetPost
     */
    readonly teslaConnectionGetPaginatedDto?: TeslaConnectionGetPaginatedDto
}

/**
 * Request parameters for apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost operation in TeslaConnectionsApi.
 * @export
 * @interface TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPostRequest
 */
export interface TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost
     */
    readonly teslaConnectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete operation in TeslaConnectionsApi.
 * @export
 * @interface TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDeleteRequest
 */
export interface TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDeleteRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete
     */
    readonly teslaConnectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet operation in TeslaConnectionsApi.
 * @export
 * @interface TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGetRequest
 */
export interface TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet
     */
    readonly teslaConnectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * Request parameters for apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost operation in TeslaConnectionsApi.
 * @export
 * @interface TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPostRequest
 */
export interface TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost
     */
    readonly teslaConnectionId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost
     */
    readonly nexusOpsAppVersion?: string
}

/**
 * TeslaConnectionsApi - object-oriented interface
 * @export
 * @class TeslaConnectionsApi
 * @extends {BaseAPI}
 */
export class TeslaConnectionsApi extends BaseAPI {
    /**
     * 
     * @param {TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaConnectionsApi
     */
    public apiV01DemoProvidersTeslaConnectionsGetPost(requestParameters: TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsGetPostRequest, options?: RawAxiosRequestConfig) {
        return TeslaConnectionsApiFp(this.configuration).apiV01DemoProvidersTeslaConnectionsGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.teslaConnectionGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaConnectionsApi
     */
    public apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost(requestParameters: TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPostRequest, options?: RawAxiosRequestConfig) {
        return TeslaConnectionsApiFp(this.configuration).apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdAuthTokensRefreshPost(requestParameters.nexusOpsTenant, requestParameters.teslaConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaConnectionsApi
     */
    public apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete(requestParameters: TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TeslaConnectionsApiFp(this.configuration).apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdDelete(requestParameters.nexusOpsTenant, requestParameters.teslaConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaConnectionsApi
     */
    public apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet(requestParameters: TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGetRequest, options?: RawAxiosRequestConfig) {
        return TeslaConnectionsApiFp(this.configuration).apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdGet(requestParameters.nexusOpsTenant, requestParameters.teslaConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaConnectionsApi
     */
    public apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost(requestParameters: TeslaConnectionsApiApiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPostRequest, options?: RawAxiosRequestConfig) {
        return TeslaConnectionsApiFp(this.configuration).apiV01DemoProvidersTeslaConnectionsTeslaConnectionIdVehiclesRefreshPost(requestParameters.nexusOpsTenant, requestParameters.teslaConnectionId, requestParameters.nexusOpsAppVersion, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeslaFeatureInfoApi - axios parameter creator
 * @export
 */
export const TeslaFeatureInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Enabled regardless of the corresponding feature flag enabled.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [vehicleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaFeatureInfoGet: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaFeatureInfoGet', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v0.1-demo/providers/tesla/feature-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeslaFeatureInfoApi - functional programming interface
 * @export
 */
export const TeslaFeatureInfoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeslaFeatureInfoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Enabled regardless of the corresponding feature flag enabled.
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {string} [vehicleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaFeatureInfoGet(nexusOpsTenant: string, nexusOpsAppVersion?: string, vehicleId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaFeatureInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaFeatureInfoGet(nexusOpsTenant, nexusOpsAppVersion, vehicleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaFeatureInfoApi.apiV01DemoProvidersTeslaFeatureInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeslaFeatureInfoApi - factory interface
 * @export
 */
export const TeslaFeatureInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeslaFeatureInfoApiFp(configuration)
    return {
        /**
         * 
         * @summary Enabled regardless of the corresponding feature flag enabled.
         * @param {TeslaFeatureInfoApiApiV01DemoProvidersTeslaFeatureInfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaFeatureInfoGet(requestParameters: TeslaFeatureInfoApiApiV01DemoProvidersTeslaFeatureInfoGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaFeatureInfoDto> {
            return localVarFp.apiV01DemoProvidersTeslaFeatureInfoGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV01DemoProvidersTeslaFeatureInfoGet operation in TeslaFeatureInfoApi.
 * @export
 * @interface TeslaFeatureInfoApiApiV01DemoProvidersTeslaFeatureInfoGetRequest
 */
export interface TeslaFeatureInfoApiApiV01DemoProvidersTeslaFeatureInfoGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaFeatureInfoApiApiV01DemoProvidersTeslaFeatureInfoGet
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaFeatureInfoApiApiV01DemoProvidersTeslaFeatureInfoGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof TeslaFeatureInfoApiApiV01DemoProvidersTeslaFeatureInfoGet
     */
    readonly vehicleId?: string
}

/**
 * TeslaFeatureInfoApi - object-oriented interface
 * @export
 * @class TeslaFeatureInfoApi
 * @extends {BaseAPI}
 */
export class TeslaFeatureInfoApi extends BaseAPI {
    /**
     * 
     * @summary Enabled regardless of the corresponding feature flag enabled.
     * @param {TeslaFeatureInfoApiApiV01DemoProvidersTeslaFeatureInfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaFeatureInfoApi
     */
    public apiV01DemoProvidersTeslaFeatureInfoGet(requestParameters: TeslaFeatureInfoApiApiV01DemoProvidersTeslaFeatureInfoGetRequest, options?: RawAxiosRequestConfig) {
        return TeslaFeatureInfoApiFp(this.configuration).apiV01DemoProvidersTeslaFeatureInfoGet(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.vehicleId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeslaVehiclesApi - axios parameter creator
 * @export
 */
export const TeslaVehiclesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TeslaVehicleGetPaginatedDto} [teslaVehicleGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesGetPost: async (nexusOpsTenant: string, nexusOpsAppVersion?: string, teslaVehicleGetPaginatedDto?: TeslaVehicleGetPaginatedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesGetPost', 'nexusOpsTenant', nexusOpsTenant)
            const localVarPath = `/api/v0.1-demo/providers/tesla/vehicles/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teslaVehicleGetPaginatedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost', 'vehicleId', vehicleId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/vehicles/{vehicleId}/commands/door-lock`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isUseDemoData !== undefined) {
                localVarQueryParameter['isUseDemoData'] = isUseDemoData;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost', 'vehicleId', vehicleId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/vehicles/{vehicleId}/commands/door-unlock`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isUseDemoData !== undefined) {
                localVarQueryParameter['isUseDemoData'] = isUseDemoData;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost', 'vehicleId', vehicleId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/vehicles/{vehicleId}/commands/flash-lights`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isUseDemoData !== undefined) {
                localVarQueryParameter['isUseDemoData'] = isUseDemoData;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost', 'vehicleId', vehicleId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/vehicles/{vehicleId}/commands/honk-horn`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isUseDemoData !== undefined) {
                localVarQueryParameter['isUseDemoData'] = isUseDemoData;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost', 'vehicleId', vehicleId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/vehicles/{vehicleId}/commands/remote-start-drive`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isUseDemoData !== undefined) {
                localVarQueryParameter['isUseDemoData'] = isUseDemoData;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost', 'vehicleId', vehicleId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/vehicles/{vehicleId}/commands/wake-up`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isUseDemoData !== undefined) {
                localVarQueryParameter['isUseDemoData'] = isUseDemoData;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isIgnoreCache] 
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdGet: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isIgnoreCache?: boolean, isUseDemoData?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/vehicles/{vehicleId}`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isIgnoreCache !== undefined) {
                localVarQueryParameter['isIgnoreCache'] = isIgnoreCache;
            }

            if (isUseDemoData !== undefined) {
                localVarQueryParameter['isUseDemoData'] = isUseDemoData;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isIgnoreCache] 
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet: async (nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isIgnoreCache?: boolean, isUseDemoData?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nexusOpsTenant' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet', 'nexusOpsTenant', nexusOpsTenant)
            // verify required parameter 'vehicleId' is not null or undefined
            assertParamExists('apiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet', 'vehicleId', vehicleId)
            const localVarPath = `/api/v0.1-demo/providers/tesla/vehicles/{vehicleId}/vehicle-data`
                .replace(`{${"vehicleId"}}`, encodeURIComponent(String(vehicleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JwtBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isIgnoreCache !== undefined) {
                localVarQueryParameter['isIgnoreCache'] = isIgnoreCache;
            }

            if (isUseDemoData !== undefined) {
                localVarQueryParameter['isUseDemoData'] = isUseDemoData;
            }

            if (nexusOpsAppVersion != null) {
                localVarHeaderParameter['NexusOps-App-Version'] = String(nexusOpsAppVersion);
            }

            if (nexusOpsTenant != null) {
                localVarHeaderParameter['NexusOps-Tenant'] = String(nexusOpsTenant);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeslaVehiclesApi - functional programming interface
 * @export
 */
export const TeslaVehiclesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeslaVehiclesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {TeslaVehicleGetPaginatedDto} [teslaVehicleGetPaginatedDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaVehiclesGetPost(nexusOpsTenant: string, nexusOpsAppVersion?: string, teslaVehicleGetPaginatedDto?: TeslaVehicleGetPaginatedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationDtoOfTeslaVehicleListItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaVehiclesGetPost(nexusOpsTenant, nexusOpsAppVersion, teslaVehicleGetPaginatedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaVehiclesApi.apiV01DemoProvidersTeslaVehiclesGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaVehicleCommandResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost(nexusOpsTenant, vehicleId, nexusOpsAppVersion, isUseDemoData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaVehiclesApi.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaVehicleCommandResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost(nexusOpsTenant, vehicleId, nexusOpsAppVersion, isUseDemoData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaVehiclesApi.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaVehicleCommandResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost(nexusOpsTenant, vehicleId, nexusOpsAppVersion, isUseDemoData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaVehiclesApi.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaVehicleCommandResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost(nexusOpsTenant, vehicleId, nexusOpsAppVersion, isUseDemoData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaVehiclesApi.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaVehicleCommandResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost(nexusOpsTenant, vehicleId, nexusOpsAppVersion, isUseDemoData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaVehiclesApi.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isUseDemoData?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaVehicleWakeUpResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost(nexusOpsTenant, vehicleId, nexusOpsAppVersion, isUseDemoData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaVehiclesApi.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isIgnoreCache] 
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaVehiclesVehicleIdGet(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isIgnoreCache?: boolean, isUseDemoData?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaVehicleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaVehiclesVehicleIdGet(nexusOpsTenant, vehicleId, nexusOpsAppVersion, isIgnoreCache, isUseDemoData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaVehiclesApi.apiV01DemoProvidersTeslaVehiclesVehicleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} nexusOpsTenant   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
         * @param {string} vehicleId 
         * @param {string} [nexusOpsAppVersion] Version of FE app that makes the request.
         * @param {boolean} [isIgnoreCache] 
         * @param {boolean} [isUseDemoData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet(nexusOpsTenant: string, vehicleId: string, nexusOpsAppVersion?: string, isIgnoreCache?: boolean, isUseDemoData?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeslaVehicleDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet(nexusOpsTenant, vehicleId, nexusOpsAppVersion, isIgnoreCache, isUseDemoData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeslaVehiclesApi.apiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeslaVehiclesApi - factory interface
 * @export
 */
export const TeslaVehiclesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeslaVehiclesApiFp(configuration)
    return {
        /**
         * 
         * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesGetPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesGetPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginationDtoOfTeslaVehicleListItemDto> {
            return localVarFp.apiV01DemoProvidersTeslaVehiclesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.teslaVehicleGetPaginatedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaVehicleCommandResultDto> {
            return localVarFp.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaVehicleCommandResultDto> {
            return localVarFp.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaVehicleCommandResultDto> {
            return localVarFp.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaVehicleCommandResultDto> {
            return localVarFp.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaVehicleCommandResultDto> {
            return localVarFp.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaVehicleWakeUpResultDto> {
            return localVarFp.apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdGet(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaVehicleDto> {
            return localVarFp.apiV01DemoProvidersTeslaVehiclesVehicleIdGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isIgnoreCache, requestParameters.isUseDemoData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeslaVehicleDataDto> {
            return localVarFp.apiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isIgnoreCache, requestParameters.isUseDemoData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV01DemoProvidersTeslaVehiclesGetPost operation in TeslaVehiclesApi.
 * @export
 * @interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesGetPostRequest
 */
export interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesGetPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesGetPost
     */
    readonly nexusOpsTenant: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesGetPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {TeslaVehicleGetPaginatedDto}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesGetPost
     */
    readonly teslaVehicleGetPaginatedDto?: TeslaVehicleGetPaginatedDto
}

/**
 * Request parameters for apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost operation in TeslaVehiclesApi.
 * @export
 * @interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPostRequest
 */
export interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost
     */
    readonly isUseDemoData?: boolean
}

/**
 * Request parameters for apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost operation in TeslaVehiclesApi.
 * @export
 * @interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPostRequest
 */
export interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost
     */
    readonly isUseDemoData?: boolean
}

/**
 * Request parameters for apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost operation in TeslaVehiclesApi.
 * @export
 * @interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPostRequest
 */
export interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost
     */
    readonly isUseDemoData?: boolean
}

/**
 * Request parameters for apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost operation in TeslaVehiclesApi.
 * @export
 * @interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPostRequest
 */
export interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost
     */
    readonly isUseDemoData?: boolean
}

/**
 * Request parameters for apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost operation in TeslaVehiclesApi.
 * @export
 * @interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePostRequest
 */
export interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost
     */
    readonly isUseDemoData?: boolean
}

/**
 * Request parameters for apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost operation in TeslaVehiclesApi.
 * @export
 * @interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPostRequest
 */
export interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPostRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost
     */
    readonly isUseDemoData?: boolean
}

/**
 * Request parameters for apiV01DemoProvidersTeslaVehiclesVehicleIdGet operation in TeslaVehiclesApi.
 * @export
 * @interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdGetRequest
 */
export interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdGet
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdGet
     */
    readonly isIgnoreCache?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdGet
     */
    readonly isUseDemoData?: boolean
}

/**
 * Request parameters for apiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet operation in TeslaVehiclesApi.
 * @export
 * @interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGetRequest
 */
export interface TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGetRequest {
    /**
     *   Tenant identifier, which specifies in a context of what tenant request is made.     When calling the endpoint via API client generated from Open API (Swagger), you can pass empty value or undefined,   and set tenant identifier header value manually.   For instance, in TS API client generated via openapi-generator-cli, you can configure default HTTP headers globally and avoid passing actual   header value on each request.  
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet
     */
    readonly nexusOpsTenant: string

    /**
     * 
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet
     */
    readonly vehicleId: string

    /**
     * Version of FE app that makes the request.
     * @type {string}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet
     */
    readonly nexusOpsAppVersion?: string

    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet
     */
    readonly isIgnoreCache?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet
     */
    readonly isUseDemoData?: boolean
}

/**
 * TeslaVehiclesApi - object-oriented interface
 * @export
 * @class TeslaVehiclesApi
 * @extends {BaseAPI}
 */
export class TeslaVehiclesApi extends BaseAPI {
    /**
     * 
     * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaVehiclesApi
     */
    public apiV01DemoProvidersTeslaVehiclesGetPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesGetPostRequest, options?: RawAxiosRequestConfig) {
        return TeslaVehiclesApiFp(this.configuration).apiV01DemoProvidersTeslaVehiclesGetPost(requestParameters.nexusOpsTenant, requestParameters.nexusOpsAppVersion, requestParameters.teslaVehicleGetPaginatedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaVehiclesApi
     */
    public apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPostRequest, options?: RawAxiosRequestConfig) {
        return TeslaVehiclesApiFp(this.configuration).apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorLockPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaVehiclesApi
     */
    public apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPostRequest, options?: RawAxiosRequestConfig) {
        return TeslaVehiclesApiFp(this.configuration).apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsDoorUnlockPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaVehiclesApi
     */
    public apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPostRequest, options?: RawAxiosRequestConfig) {
        return TeslaVehiclesApiFp(this.configuration).apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsFlashLightsPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaVehiclesApi
     */
    public apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPostRequest, options?: RawAxiosRequestConfig) {
        return TeslaVehiclesApiFp(this.configuration).apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsHonkHornPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaVehiclesApi
     */
    public apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePostRequest, options?: RawAxiosRequestConfig) {
        return TeslaVehiclesApiFp(this.configuration).apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsRemoteStartDrivePost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaVehiclesApi
     */
    public apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPostRequest, options?: RawAxiosRequestConfig) {
        return TeslaVehiclesApiFp(this.configuration).apiV01DemoProvidersTeslaVehiclesVehicleIdCommandsWakeUpPost(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isUseDemoData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaVehiclesApi
     */
    public apiV01DemoProvidersTeslaVehiclesVehicleIdGet(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdGetRequest, options?: RawAxiosRequestConfig) {
        return TeslaVehiclesApiFp(this.configuration).apiV01DemoProvidersTeslaVehiclesVehicleIdGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isIgnoreCache, requestParameters.isUseDemoData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeslaVehiclesApi
     */
    public apiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet(requestParameters: TeslaVehiclesApiApiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGetRequest, options?: RawAxiosRequestConfig) {
        return TeslaVehiclesApiFp(this.configuration).apiV01DemoProvidersTeslaVehiclesVehicleIdVehicleDataGet(requestParameters.nexusOpsTenant, requestParameters.vehicleId, requestParameters.nexusOpsAppVersion, requestParameters.isIgnoreCache, requestParameters.isUseDemoData, options).then((request) => request(this.axios, this.basePath));
    }
}



